import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  text: {
    color: theme.colours.content.fontColor,
    fontSize: theme.text.fontSize,
    fontWeight: theme.text.fontWeight,
    textAlign: "justify",
    "& h1": {
      fontWeight: 400
    }
  }
});

const TextSection = ({ children, classes, className }) => (
  <div className={`${classes.text} ${className}`}>{children}</div>
);

TextSection.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string
};

export default injectSheet(styles)(TextSection);



// WEBPACK FOOTER //
// ./src/components/TextSection.jsx